<template>
  <div>
    <div class="content">
      <div class="content-add-detail">
        <el-form :model="queryParams" label-position="left" class="demo-form-inline">
          <div class="add-basic-information">
            <div class="add-title">
              <span class="basic title-font-style">发货信息</span>
            </div>
            <div class="add-content details-line-height" style="padding:0 0 10px 50px;">
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="发货编号：">
                      <span>{{ queryParams.deliverNumber ||'--'}}</span>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="配送方式：">
                      <span>
                        {{
                        queryParams.logisticType ||'--'
                        }}
                      </span>
                    </el-form-item>
                  </el-col>
                </el-col>

                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="入库仓库：">
                      {{
                      queryParams.storageName ||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="仓库地址：">
                      {{
                      queryParams.storageAddress ||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="联系电话：">
                      {{
                      queryParams.storagePhone ||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>

                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="入库类型：">
                      {{
                      queryParams.instockType ||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="发起人：">
                      {{
                      queryParams.createUser ||'--'
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="发起时间：">
                      {{
                      queryParams.createDate | dateFilterL
                      }}
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="add-basic-information">
            <div class="add-title">
              <span class="basic title-font-style">物流信息</span>
            </div>
            <div class="add-content details-line-height" style="padding:0 0 10px 50px;">
              <el-row v-for="(item,index) in distribution" :key="index">
                <el-col :span="8">
                  <el-form-item label="物流公司：">
                    <span>{{item.logisticCompany ||'--'}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="物流单号：" label-width="71px" >
                      <el-tooltip
                        :content="item.logisticNumber"
                        class="overflow-ellipsis"
                        effect="dark"
                        placement="top-start"
                      >
                        <span style="width:100%">{{item.logisticNumber|| '--'}}</span>
                      </el-tooltip>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="物流费用：">
                      <span>{{item.expressFee ||'--'}}</span>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="add-basic-information">
            <div class="add-title add-title1" style="padding:20px 0 0 20px;">
              <div>
                <span class="basic title-font-style">入库清单</span>
              </div>
              <span style="text-align:right;padding-right:20px;">
                <el-button plain @click="toExport">导出入库清单</el-button>
                <el-button plain v-show="instockState === 2" @click="typeShelf">批量设置货架</el-button>
              </span>
            </div>
            <div class="box-table">
              <el-table
                max-height="378"
                v-show="instockState === 2"
                border
                ref="tableRef"
                tooltip-effect="dark"
                :data="list"
                :header-cell-style="tableHeader"
                v-loading="loadingTable"
                element-loading-text="拼命加载中请稍后..."
                element-loading-spinner="el-icon-loading"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="品牌" prop="brandName" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.brandName || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="产品名称" prop="proName" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.proName || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="型号" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div
                      class="approval line-limit-length"
                      @click="detailModel(scope.row)"
                    >{{ scope.row.proModel ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="订货号" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.proOrdernum ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="单位">
                  <template slot-scope="scope">
                    <div>{{ scope.row.proUnit ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="调拨仓库" show-overflow-tooltip v-if="instockType === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.fromStorageName ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="调拨货架" show-overflow-tooltip v-if="instockType === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.fromShelvesName ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="数量" v-if="instockState === 1">
                  <template slot-scope="scope">
                    <div>{{ String(scope.row.deliverCount) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="实际入库数">
                  <template slot-scope="scope">
                    <div>{{ String(scope.row.warehouseCount) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="产品序列号" v-if="instockState === 1 || instockState === 2">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toEntry(scope.$index,scope.row)"
                      v-show="!scope.row.addEdit"
                    >点击录入</el-button>
                    <el-button
                      type="text"
                      @click="toEntry(scope.$index,scope.row)"
                      v-show="scope.row.addEdit"
                    >编辑</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="产品序列号" v-if="instockState === 3">
                  <template slot-scope="scope">
                    <el-button type="text" @click="toEntry(scope.$index,scope.row)" plain>查看</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="货架" v-if="instockState === 2">
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.ssId"
                      ref="select"
                      :filter-method="dataFilter"
                      @focus="add(scope.$index)"
                      @visible-change='visibleChange(scope.$index)'
                      filterable
                      placeholder="请选择货架"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.shelvesName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="入库批次" v-if="instockState !== 1" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.batchNumber ||'--'}}</div>
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                max-height="378"
                v-if="instockState === 1"
                border
                ref="tableRef"
                tooltip-effect="dark"
                :data="list"
                :header-cell-style="tableHeader"
                v-loading="loadingTable"
                element-loading-text="拼命加载中请稍后..."
                element-loading-spinner="el-icon-loading"
              >
                <el-table-column label="品牌" prop="brandName" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.brandName || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="产品名称" prop="proName" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.proName || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="型号" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div
                      class="approval line-limit-length"
                      @click="detailModel(scope.row)"
                    >{{ scope.row.proModel ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="订货号" prop="proOrdernum" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{scope.row.proOrdernum || '--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="单位">
                  <template slot-scope="scope">
                    <div>{{ scope.row.proUnit ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="调拨仓库" show-overflow-tooltip v-if="instockType === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.fromStorageName ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="调拨货架" show-overflow-tooltip v-if="instockType === 2">
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.fromShelvesName ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="数量" v-if="instockState === 1">
                  <template slot-scope="scope">
                    <div>{{ String(scope.row.deliverCount) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="实际入库数">
                  <template slot-scope="scope">
                    <div>{{ String(scope.row.warehouseCount) ||'--'}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="产品序列号" v-if="instockState === 1 || instockState === 2">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toEntry(scope.$index,scope.row)"
                      v-show="!scope.row.addEdit"
                    >点击录入</el-button>
                    <el-button
                      type="text"
                      @click="toEntry(scope.$index,scope.row)"
                      v-show="scope.row.addEdit"
                    >编辑</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="产品序列号" v-if="instockState === 3">
                  <template slot-scope="scope">
                    <el-button type="text" @click="toEntry(scope.$index,scope.row)">查看</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  fixed="right"
                  v-if="instockState === 1 && instockType === 1"
                 >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toVacancy(scope.$index,scope.row)"
                      v-if="scope.row.showLack"
                    >报缺</el-button>
                    <el-button v-if="!scope.row.showLack" type="text" @click="toSee(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  fixed="right"
                  v-if="instockState === 1 && instockType === 2"
                 >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toVacancy(scope.$index,scope.row)"
                      v-if="scope.row.isLack"
                    >报缺</el-button>
                    <el-button
                      v-if="scope.row.isLack === false && instockType === 2"
                      type="text"
                      @click="toSee(scope.row)"
                    >查看</el-button>
                  </template>
                </el-table-column>
                <el-table-column label="入库批次" v-if="instockState !== 1" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="line-limit-length">{{ scope.row.batchNumber ||'--'}}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="padding:0 0 30px 20px;">
              <div v-show="instockState === 1">
                <div style="margin-bottom:20px;color:#D35E5E;font-size:12px;">
                  *入库过程中如发现缺失，请正常验收入库其他产品，缺失产品可点击报缺按钮，提交报缺。
                  <span
                    v-if="instockType !== 2"
                  >作废入库单，整单产品退回采购待发货清单，由采购重新发起入库。</span>
                </div>
                <el-button type="primary" @click="acceptance">确认验收</el-button>
                <el-button @click="cancellation" v-if="instockType !== 2">作废入库单</el-button>
              </div>
              <div v-show="instockState === 2">
                <el-button type="primary" @click="confirm">确认入库</el-button>
                <div style="padding-top:10px;">确认入库后自动生成入库批次</div>
              </div>
            </div>
          </div>
        </el-form>
        <!-- -------------作废入库单 确认提示框----------------- -->
        <el-dialog
          :visible.sync="cancellationDialog"
          class="dialog-address"
          width="437px"
          title="作废入库单"
        >
          <div class="dialog-tip" style="padding-left:30px;">确定作废入库单？</div>
          <span slot="footer" class="dialog-center">
            <el-button @click="onSubmit" type="primary">确定</el-button>
            <el-button @click="cancellationDialog=false">取消</el-button>
          </span>
        </el-dialog>
        <!-- -------------确认验证 确认提示框----------------- -->
        <el-dialog
          :visible.sync="acceptanceDialog"
          class="dialog-address"
          width="437px"
          title="验收确认"
        >
          <div class="dialog-tip" style="padding-left:30px;">确认已完成验收?</div>
          <span slot="footer" class="dialog-center">
            <el-button v-if="instockType !==2" @click="acceptanceSubmit" type="primary">确定</el-button>
            <!-- 调拨入库确认 显示报缺备注 -->
            <el-button v-if="instockType === 2" @click="purchaseSubmit" type="primary">确定</el-button>
            <el-button @click="acceptanceDialog=false">取消</el-button>
          </span>
        </el-dialog>
        <!-- 调拨验收前的报缺备注 -->
        <el-dialog :visible.sync="purchaseDialog" class="dialog-address" width="437px" title="验收确认">
          <div class="dialog-tip" style="padding-left:30px;">
            <el-form class="demo-form-inline">
              <el-form-item :rules="filter_rules({required:true})">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 4, maxRows: 5 }"
                  placeholder="存在报缺产品，请填写备注！"
                  v-model.trim="acceptMark"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-center">
            <!-- 采购入库确认 显示报缺备注 -->
            <el-button  @click="Lacksumbit" type="primary">确定</el-button>
            <el-button @click="purchaseDialog=false">取消</el-button>
          </span>
        </el-dialog>

        <!-- ------------- 点击录入弹框----------------------- -->
        <el-dialog
          :visible.sync="enteringDialog"
          class="dialog-address"
          width="660px"
          title="录入产品序列号"
          @close="onClose"
        >
          <el-row :gutter="20">
            <el-col :span="24">
              <tags-input v-model="textarea" ref="tagsInputRefs" />
            </el-col>
          </el-row>
          <el-row :gutter="20" style="margin-top:10px;">
            <el-col :span="4">
              <el-button type="text" @click="downLoadFile" style="padding-left:30px;">下载模板</el-button>
            </el-col>
            <el-col :span="20">
              <el-upload
                class="upload-demo"
                action="api/purchaseContractDeliverBase/queryLeadSerialCode"
                :headers="myHeaders"
                :on-success="onSuccess"
                :show-file-list="false"
              >
                <el-button type="text">导入序列号</el-button>
              </el-upload>
            </el-col>
          </el-row>
          <span slot="footer" class="dialog-center">
            <el-button @click="entrySubmit" type="primary">确定</el-button>
            <el-button @click="cancelSericode">取消</el-button>
          </span>
        </el-dialog>
        <!-- ----------------报缺------------------------------- -->
        <el-dialog :visible.sync="lackDialog" class="dialog-address" width="600px" title="报缺">
          <el-form label-width="100px" class="demo-form-inline" style="padding-left:30px;">
            <el-form-item label="实际入库数：" :rules="filter_rules({required:true})">
              <el-input-number
                style="width:100%"
                :controls="false"
                :min="0"
                :max="deliverCount"
                placeholder="填写该产品实际入库数量"
                v-model="warehouseCount"
                :disabled="showSeeLack"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="备注：" :rules="filter_rules({required:true})">
              <el-input
                :disabled="showSeeLack"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 4 }"
                placeholder="可录入报缺说明"
                v-model.trim="marks"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-center" v-show="showSeeLack === false">
            <el-button @click="lackSubmit" type="primary">确定</el-button>
            <el-button @click="lackDialog=false">取消</el-button>
          </span>
        </el-dialog>
        <!-- ----------------- 入库确认 ------------------------- -->
        <el-dialog
          :visible.sync="WareHousingDialog"
          class="dialog-address"
          width="437px"
          title="入库确认"
        >
          <div class="dialog-tip" style="padding-left:30px;">确定入库上架该批产品？</div>
          <span slot="footer" class="dialog-center">
            <el-button @click="confirmSubmit" :disabled="stockDisabled" type="primary">确定</el-button>
            <el-button @click="WareHousingDialog=false">取消</el-button>
          </span>
        </el-dialog>
        <!------------------ 批量录入货架 ------------------------- -->
        <el-dialog :visible.sync="shelfDialog" class="dialog-address" width="437px" title="批量设置货架">
          <div class="dialog-tip" style="padding-left:30px;">
            <el-form>
              <el-form-item label="货架：">
                <el-select
                  style="width:60%"
                  v-model="shelvesId"
                  @focus="addFocus"
                  :filter-method="BathDataFilter"
                  filterable
                  placeholder="请选择货架"
                >
                  <el-option
                    v-for="item in bathOptions"
                    :key="item.id"
                    :label="item.shelvesName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <span slot="footer" class="dialog-center">
            <el-button @click="shelveSubmit" type="primary">确定</el-button>
            <el-button @click="shelfDialog=false">取消</el-button>
          </span>
        </el-dialog>
        <!-- --------------------待入库 查看序列号侧边栏---------------------- -->
        <see-shipment ref="seeShipmentRefs"></see-shipment>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryStorageDeliverContentVo,
  updateCancellation,
  addAllotLack,
  updateAccept,
  addInstock,
  queryStorageShelves
} from '@/api/storage/storage'
import {
  addStorageInstockCoeDerive,
  querySystemAttachmentAddressVo
} from '@/api/purchase/purchaseManage'
import { downLoadFileBlob, duplicates, uploadDownExcel } from '@/util/tool'
import logisticsSlider from '../slideBar/logisticsSlider'
import TagsInput from '@/components/inputTags/index.vue'
import { getToken } from '@/util/auth' // get token from cookie

export default {
  components: {
    'see-shipment': logisticsSlider,
    TagsInput
  },
  data() {
    return {
      shelvesId: '', // 批量设置货架id
      shelfDialog: false, // 批量设置货架
      options: [], // 货架下拉框
      bathOptions: [], // 批量设置货架下拉框
      optionsCopy: [],
      textarea: [], // 序列号
      myHeaders: {},
      purchaseDialog: false, // 报缺备注
      showSeeLack: false, // 查看报缺禁用状态
      cancellationDialog: false,
      acceptanceDialog: false,
      enteringDialog: false,
      lackDialog: false,
      WareHousingDialog: false,
      checkDialog: false,
      acceptMark: '', // 验收报缺备注
      deliverCount: '', // 数量
      list: [], // 入库清单
      distribution: [
        {
          logisticCompany: '',
          logisticNumber: '',
          expressFee: ''
        }
      ], // 物流信息、
      queryParams: {}, // 发货信息
      pitchOnPpId: [],
      loadingTable: false,
      isUpdate: false,
      mark: '', // 中通备注
      instockState: '', // 入库状态 1待验收 2待入库 3已入库 4作废
      logisticType: '', // 配送方式: 1物流入库 2配送入库,
      warehouseCount: '',
      instockType: '', // 入库类型
      marks: '',
      index: '',
      serialCode: '',
      index2: '',
      index3: '',
      vals: '', // 下标
      values: '',
      stockDisabled: false, // 入库确认按钮禁用状态
      changeList: [] // 选中的表格
    }
  },
  mounted() {
    this.queryStorageDeliverContentVo()
    this.distributionType = Number(this.$route.query.distributionType)
    this.instockState = Number(this.$route.query.instockState)
    this.instockType = Number(this.$route.query.instockType)
  },
  methods: {
    visibleChange(i) {
      if (i) {
        if (this.$refs.select.previousQuery) {
          this.$refs.select.previousQuery = ''
          this.$set(this.list[i], 'ssId', '')
        }
      }
    },
    add(i) {
      this.options = this.optionsCopy
      this.vals = i
      this.$refs.select.previousQuery = ''
      this.$set(this.list[this.vals], 'ssId', '')
    },
    addFocus() {
      this.bathOptions = this.optionsCopy
      this.shelvesId = ''
    },
    BathDataFilter(val) {
      // 批量设置货架搜索事件
      if (val) {
        // val存在
        this.bathOptions = this.optionsCopy.filter(item => {
          return (
            item.shelvesName.indexOf(val) !== -1 ||
            item.shelvesName.toUpperCase().indexOf(val.toUpperCase()) !== -1
          )
        })
        if (this.bathOptions.length === 1) {
          this.shelvesId = this.bathOptions[0].id
        } else {
          if (this.shelvesId) {
            this.$set(this.list[this.vals], 'ssId', '')
            this.$refs.select.previousQuery = ''
            this.bathOptions = this.optionsCopy
          }
        }
      } else {
        // val为空时，还原数组
        this.bathOptions = this.optionsCopy
      }
    },
    dataFilter(val) {
      if (val) {
        // val存在
        this.values = val
        this.options = this.optionsCopy.filter(item => {
          return (
            item.shelvesName.indexOf(val) !== -1 ||
            item.shelvesName.toUpperCase().indexOf(val.toUpperCase()) !== -1
          )
        })
        if (this.options.length === 1) {
          this.list[this.vals].ssId = this.options[0].id
        } else {
          if (this.list[this.vals].ssId) {
            this.$set(this.list[this.vals], 'ssId', '')
            this.$refs.select.previousQuery = ''
            this.options = this.optionsCopy
          }
        }
      } else {
        // val为空时，还原数组
        this.options = this.optionsCopy
      }
    },
    // 跳产品详情页
    detailModel(row) {
      this.$router.push({
        path: '/product/productManage/productDetails',
        query: { id: row.proId }
      })
    },
    //  多选
    handleSelectionChange(val) {
      this.changeList = val
    },
    // 根据bizId和入库类型instockType 获取物流入库详情
    queryStorageDeliverContentVo() {
      queryStorageDeliverContentVo(this.$route.query.id, this.$route.query.instockType)
        .then(res => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj.storageDeliverBaseVo // 发货信息
            this.distribution = res.data.obj.storageLogisticVoList // 物流信息
            res.data.obj.storageDeliverContentVoList.forEach(ele => {
              if (ele.serialCode) {
                ele.addEdit = true
              } else {
                ele.addEdit = false
              }
              if (ele.shelvesName) {
                ele.shelfEdit = true
              } else {
                ele.shelfEdit = false
              }
            })
            this.list = res.data.obj.storageDeliverContentVoList // 入库清单
            this.list.forEach(ele => {
              ele.showLack = true
            })
            this.getShelves()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // ------------------待验收-录入信息-------------------------
    // 作废入库单提示框
    cancellation() {
      this.cancellationDialog = true
    },
    // 确认作废
    onSubmit() {
      updateCancellation(this.$route.query.instockType, this.$route.query.id)
        .then(res => {
          if (res.data.code === 200) {
            this.cancellationDialog = false
            this.$message.success('作废成功')
            this.$router.push({
              path: 'logisticsGoToWarehouseList'
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 验收确认提示框
    acceptance() {
      this.acceptanceDialog = true
    },
    // 采购入库 判断是否有报缺
    purchaseSubmit() {
      // 如果存在报缺
      this.list.forEach(ele => {
        if (ele.mark) {
          this.purchaseDialog = true
        } else {
          this.purchaseDialog = false
          this.acceptanceSubmit()
        }
      })
    },
    Lacksumbit() {
      this.acceptanceSubmit()
      this.purchaseDialog = false
    },
    // 确认验收
    acceptanceSubmit() {
      if (this.list.find(m => m.mark)) {
        const params = {
          acceptMark: this.acceptMark,
          instockType: this.$route.query.instockType,
          bizId: this.$route.query.id,
          instockNumber: this.instockNumber,
          storageDeliverBaseVo: this.queryParams,
          storageDeliverContentVoList: this.list
        }
        updateAccept(params)
          .then(res => {
            if (res.data.code === 200) {
              this.acceptanceDialog = false
              this.$router.push({
                name: 'logisticsGoToDetail',
                query: {
                  instockState: 2,
                  instockType: this.$route.query.instockType,
                  id: this.$route.query.id,
                  logisticType: this.$route.query.logisticType
                }
              })
              this.queryStorageDeliverContentVo()
              this.distributionType = +this.$route.query.distributionType
              this.instockState = +this.$route.query.instockState
              this.purchaseDialog = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        const params = {
          acceptMark: null,
          instockType: this.$route.query.instockType,
          bizId: this.$route.query.id,
          instockNumber: this.instockNumber,
          storageDeliverBaseVo: this.queryParams,
          storageDeliverContentVoList: this.list
        }
        updateAccept(params)
          .then(res => {
            if (res.data.code === 200) {
              this.acceptanceDialog = false
              this.$router.push({
                name: 'logisticsGoToDetail',
                query: {
                  instockState: 2,
                  instockType: this.$route.query.instockType,
                  id: this.$route.query.id,
                  logisticType: this.$route.query.logisticType
                }
              })
              this.queryStorageDeliverContentVo()
              this.distributionType = +this.$route.query.distributionType
              this.instockState = +this.$route.query.instockState
              this.purchaseDialog = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    // 点击录入提示框
    toEntry($index, row) {
      this.myHeaders = {
        Authorization: ` Bearer ${getToken()}`
      }
      this.index2 = $index
      if (row.serialCode) {
        this.textarea = row.serialCode.split(';')
      } else {
        this.textarea = []
      }
      this.enteringDialog = true
    },
    // 确认录入
    entrySubmit() {
      if (this.list[this.index2].addEdit === false) {
        if (this.textarea.length === 0) {
          this.$message.error('请输入至少一个序列号！')
        } else {
          this.list[this.index2].serialCode = this.textarea.join(';')
          this.enteringDialog = false
          this.list[this.index2].addEdit = true
        }
      } else {
        if (this.textarea.length === 0) {
          this.list[this.index2].serialCode = ''
          this.list[this.index2].addEdit = false
          this.enteringDialog = false
        } else {
          this.enteringDialog = false
          this.list[this.index2].serialCode = this.textarea.join(';')
          this.list[this.index2].addEdit = true
        }
      }
    },
    downLoadFile() {
      querySystemAttachmentAddressVo('5fe97edacb608efc411daeb9').then(res => {
        if (res.data.code === 200) {
          uploadDownExcel(this.$store.state.https + res.data.obj.filePath, '通用导入序列号模板')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 取消录入序列号
    cancelSericode() {
      this.enteringDialog = false
      this.textarea = []
      this.$refs.tagsInputRefs.current = ''
    },
    onClose() {
      this.enteringDialog = false
      this.textarea = []
      this.$refs.tagsInputRefs.current = ''
    },
    onSuccess(response, file, fileList) {
      const data = response.obj.split(';')
      const textareaList = this.textarea.concat(data)
      this.textarea = duplicates(textareaList)
    },
    // 查看报缺
    toSee(row) {
      this.lackDialog = true
      this.marks = row.mark
      this.warehouseCount = row.warehouseCount
      this.showSeeLack = true
    },
    // 报缺提示框
    toVacancy($index, row) {
      this.deliverCount = row.deliverCount
      this.warehouseCount = row.warehouseCount
      this.marks = row.mark
      this.lackDialog = true
      this.showSeeLack = false
      this.index = $index
    },
    // 确认报缺
    // 点击确定后，关闭弹窗并把实际入库数量同步到入库清单中，
    lackSubmit() {
      if (this.instockType === 2) {
        // 调拨入库需要调接口
        const arr = JSON.parse(JSON.stringify(this.list))
        var params = {}
        params = arr[this.index]
        params.warehouseCount = this.warehouseCount
        params.mark = this.marks
        this.list = JSON.parse(JSON.stringify(arr))
        if (!String(this.warehouseCount) || !this.marks) {
          this.$message.error('请填写完整信息')
        } else {
          addAllotLack(this.list[this.index])
            .then(res => {
              if (res.data.code === 200) {
                this.lackDialog = false
                this.$message.success(res.data.msg)
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      } else {
        if (String(this.warehouseCount) && this.marks) {
          //  采购入库 退货入库 报缺不需要调接口
          const arr = JSON.parse(JSON.stringify(this.list))
          arr[this.index].warehouseCount = this.warehouseCount
          arr[this.index].mark = this.marks
          arr[this.index].showLack = false
          this.list = JSON.parse(JSON.stringify(arr))
          this.lackDialog = false
        } else {
          this.$message.error('请填写完整信息')
        }
      }
    },
    // --------------待入库-上架---------------

    //  获取所有货架
    getShelves() {
      queryStorageShelves(this.queryParams.sbId, {})
        .then(res => {
          if (res.data.code === 200) {
            this.options = res.data.obj
            this.optionsCopy = res.data.obj
            this.bathOptions = res.data.obj
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 批量设置货架
    typeShelf() {
      if (this.changeList.length < 1) {
        this.$message.error('请选择一条或多条')
      } else {
        this.options = this.optionsCopy
        this.shelfDialog = true
        this.shelvesId = ''
      }
    },
    shelveSubmit() {
      this.changeList.forEach(ele => {
        ele.ssId = this.shelvesId
      })
      this.shelfDialog = false
      this.$refs.tableRef.clearSelection()
    },

    // 入库确认提示框
    confirm() {
      if (!this.list.every(ele => ele.ssId)) {
        this.$message.error('未录入货架')
      } else {
        this.WareHousingDialog = true
      }
    },
    // 确认按钮
    confirmSubmit() {
      console.log(111)
      this.stockDisabled = true
      addInstock({
        instockType: this.$route.query.instockType,
        bizId: this.$route.query.id,
        instockNumber: this.instockNumber,
        storageDeliverBaseVo: this.queryParams,
        storageDeliverContentVoList: this.list
      })
        .then(res => {
          if (res.data.code === 200) {
            this.WareHousingDialog = false
            this.$router.push({
              name: 'logisticsWareDetail',
              query: {
                instockState: 3,
                instockType: this.$route.query.instockType,
                id: this.$route.query.id,
                logisticType: this.$route.query.logisticType
              }
            })
          } else {
            this.$message.error(res.data.msg)
          }
          this.stockDisabled = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 循环添加form 表单
    toAddLogistic(list) {
      list.push({})
    },
    // 删除form表单中某一条
    toDelLogistic(list, index) {
      list.splice(index, 1)
    },
    toExport() {
      const queryParams = {}
      queryParams.bizId = this.$route.query.id
      queryParams.instockType = this.$route.query.instockType
      if (this.queryParams.logisticType === '物流配送') {
        queryParams.instockUrl = this.$store.state.inventoryListGuid
      } else if (this.queryParams.logisticType === '快递配送') {
        queryParams.instockUrl = this.$store.state.expressInventoryListGuid
      } else if (this.queryParams.logisticType === '供应商配送') {
        queryParams.instockUrl = this.$store.state.supplierInventoryListGuid
      }
      addStorageInstockCoeDerive(queryParams)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 设置头部颜色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.span_row {
  display: flex;
  span {
    width: 94px;
  }
}
.add-basic-information .bottom {
  padding: 0 30px 30px 50px;
}
.add-basic-information .bottom-tip {
  margin: 15px 0;
}
.add-title1 {
  display: flex;
  justify-content: space-between;
  padding: 30px 0 0 30px;
}
.logistics-information {
  font-size: 16px;
  font-weight: bold;
  color: #4e555b;
  margin-bottom: 10px;
}
.el-tabs__nav-scroll {
  border-bottom: 1px #eeeeee solid !important;
}

</style>
